import { render, staticRenderFns } from "./Trazabilidad.vue?vue&type=template&id=6aff79b8&"
import script from "./Trazabilidad.vue?vue&type=script&lang=js&"
export * from "./Trazabilidad.vue?vue&type=script&lang=js&"
import style0 from "./Trazabilidad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports